import { contracts } from '../services/ApiService';
import { contractsConstants } from '../constants/contracts';

export const setContracts = (contractType, items = []) => ({
  type: contractsConstants.GET_CONTRACTS_SUCCESS,
  items,
  contractType,
});

export const startSetContracts = contractType => dispatch => {
  return contracts
    .getContracts(contractType)
    .then((data = {}) => dispatch(setContracts(contractType, data.items)));
};

const changeContract = (contractType, item) => ({
  type: contractsConstants.CHANGE_CONTRACT_SUCCESS,
  item,
  contractType,
});

const deleteContract = (contractType, id) => ({
  type: contractsConstants.DELETE_CONTRACT_SUCCESS,
  id,
  contractType,
});

export const changeContractFailure = () => ({ type: contractsConstants.CHANGE_CONTRACT_FAILURE });

export const startDeleteContract = (contractType, id) => dispatch => {
  return contracts
    .deleteContract(contractType, id)
    .then(() => dispatch(deleteContract(contractType, id)))
    .catch(() => dispatch(changeContractFailure()));
};

export const startSaveContract = (contractType, item) => dispatch => {
  return contracts
    .saveContract(contractType, item)
    .then(({ items = [] }) => dispatch(changeContract(contractType, items[0])))
    // .catch(() => dispatch(changeContractFailure()));
};

export const startApproveContract = (contractType, item) => dispatch => {
  return contracts
    .approveContract(contractType, item)
    .then(({ items = [] }) => dispatch(changeContract(contractType, items[0])))
};

export const startAddContract = (contractType, item) => dispatch => {
  return contracts
    .addContract(contractType, item)
    .then(({ items = [] }) => dispatch(changeContract(contractType, items[0])));
};
